import { APIcaller } from './APIcaller';
import { InvoiceControlAPIcaller } from './externalAPICallers/InvoiceControlAPIcaller';

const getInvoiceControlList = (clientId, supplierIds) =>
  APIcaller.apiPost(`/invoice-control/list`, { clientId, supplierIds });

const aggregatedAnalyseAndExport = (invoiceControlListIds) =>
  APIcaller.apiPost(`/invoice-control/export-details`, { invoiceControlListIds });

const getStoresAvailableCredits = (storeIds) =>
  APIcaller.apiPost(`/invoice-control/credits`, { storeIds });

const importInvoiceControlLists = (invoiceControlLists) =>
  InvoiceControlAPIcaller.apiPost(`/extract-invoices`, {
    invoice_control_lists: invoiceControlLists,
  });

const getById = (id) => APIcaller.apiGet(`/invoice-control/${id}`);

const getOcerizationById = (id) => APIcaller.apiGet(`/invoice-control/${id}/export-ocerization`);

const getInvoiceControlListByOrderId = (orderId) =>
  APIcaller.apiGet(`/invoice-control/orders/${orderId}`);

const updateById = (id, invoiceDate, total, invoiceNumber) =>
  InvoiceControlAPIcaller.apiPut(`/invoice`, {
    invoice_control_list_id: id,
    invoice_date: invoiceDate,
    total,
    invoice_number: invoiceNumber,
  });

const resetOrderInvoiceAssociation = (id, storeId, supplierId) =>
  InvoiceControlAPIcaller.apiPost(`/invoice/reset-mapping`, {
    invoice_control_list_id: id,
    store_id: storeId,
    supplier_id: supplierId,
  });

const deleteById = (id) =>
  InvoiceControlAPIcaller.apiDelete(`/invoice`, { invoice_control_list_id: id });

const getOrdersByInvoiceControlListId = (id) => APIcaller.apiGet(`/invoice-control/${id}/orders`);

const getAvailableOrdersToAssociate = (
  storeId,
  supplierId,
  invoiceControlListId,
  startDate,
  endDate,
) =>
  APIcaller.apiGet(`/invoice-control/available-orders`, {
    storeId,
    supplierId,
    invoiceControlListId,
    startDate,
    endDate,
  });

const deleteOrderByInvoiceControlListId = (id, orderId) =>
  InvoiceControlAPIcaller.apiDelete(`/invoice/orders`, {
    invoice_control_list_id: id,
    order_ids: [orderId],
  });

const addOrdersByInvoiceControlListId = (id, orderIds) =>
  InvoiceControlAPIcaller.apiPost(`/invoice/orders`, {
    order_ids: orderIds,
    invoice_control_list_id: id,
  });

const importInvoiceControlListFromOrder = (
  clientId,
  supplierId,
  storeId,
  orderId,
  invoiceControlList,
) =>
  APIcaller.apiPost(`/invoice-control/import-from-order`, {
    clientId,
    supplierId,
    storeId,
    orderId,
    invoiceUrl: invoiceControlList.link,
    invoiceControlListId: invoiceControlList.id,
    invoiceNumber: invoiceControlList.invoiceNumber,
    invoiceDate: invoiceControlList.invoiceDate,
    invoiceTotal: invoiceControlList.total,
  });

const getInvoiceControlPlans = () => APIcaller.apiGet(`/invoice-control/plans`);

const automaticStoresDetection = (storeIds, invoiceUrls) =>
  InvoiceControlAPIcaller.apiPost(`/extract-stores`, {
    store_ids: storeIds,
    invoice_urls: invoiceUrls,
  });

const getInvoiceControlListByIds = (invoiceControlListIds) =>
  APIcaller.apiPost(`/invoice-control/get-by-ids`, { invoiceControlListIds });

const getSupplierCustomPrompt = (supplierId, defaultPrompt = false) =>
  InvoiceControlAPIcaller.apiGet(`/custom-prompt/${supplierId}`, { default: defaultPrompt });

const upsertSupplierCustomPrompt = (supplierId, customPromptFields) =>
  InvoiceControlAPIcaller.apiPost(`/custom-prompt`, {
    supplier_id: supplierId,
    invoice_number: customPromptFields.invoiceNumber,
    excluding_taxes_invoice_total: customPromptFields.excludingTaxesInvoiceTotal,
    invoice_date: customPromptFields.invoiceDate,
    delivery_date: customPromptFields.deliveryDate,
    order_reference: customPromptFields.orderReference,
    delivery_reference: customPromptFields.deliveryReference,
    sku: customPromptFields.code,
    name: customPromptFields.name,
    quantity: customPromptFields.quantity,
    unit_price: customPromptFields.unitPrice,
    packaging: customPromptFields.packaging,
    supplier_aliases: customPromptFields.supplierAliases,
    full_prompt: customPromptFields.fullPrompt,
  });

const updateOrderData = (updatedInvoiceControlDetails) =>
  APIcaller.apiPost(`/invoice-control/update-order-data`, { updatedInvoiceControlDetails });

const createInvoiceControlMapping = (
  invoiceControlListId,
  invoiceControlId,
  orderId,
  supplierProductId,
) =>
  InvoiceControlAPIcaller.apiPost(`/invoice/mappings`, {
    invoice_control_list_id: invoiceControlListId,
    invoice_control_id: invoiceControlId,
    order_id: orderId,
    supplier_product_id: supplierProductId,
  });

const deleteInvoiceControlMapping = (invoiceControlListId, invoiceControlMappingId) =>
  InvoiceControlAPIcaller.apiDelete(`/invoice/mappings`, {
    invoice_control_list_id: invoiceControlListId,
    invoice_control_mapping_id: invoiceControlMappingId,
  });

export default {
  getById,
  updateById,
  deleteById,
  getInvoiceControlListByOrderId,
  getOcerizationById,
  getStoresAvailableCredits,
  getInvoiceControlList,
  aggregatedAnalyseAndExport,
  importInvoiceControlLists,
  getOrdersByInvoiceControlListId,
  addOrdersByInvoiceControlListId,
  deleteOrderByInvoiceControlListId,
  getAvailableOrdersToAssociate,
  resetOrderInvoiceAssociation,
  importInvoiceControlListFromOrder,
  getInvoiceControlPlans,
  automaticStoresDetection,
  getInvoiceControlListByIds,
  getSupplierCustomPrompt,
  upsertSupplierCustomPrompt,
  updateOrderData,
  createInvoiceControlMapping,
  deleteInvoiceControlMapping,
};
